/* eslint-disable no-unused-vars */
import { ColumnsProps } from 'components/Table/Table'
import { getLineTypeByTheme, LINE_TYPES } from 'config/theme.config'
import i18n from 'i18n'

// Master list of all unique columns
export const allColumns = (): ColumnsProps[] => [
  {
    align: 'right',
    fixed: true,
    name: 'order',
    title: i18n.t('tables:orderNumber')
  },
  {
    align: 'right',
    fixed: true,
    name: 'cargo',
    title: i18n.t('tables:charge')
  },
  {
    align: 'left',
    fixed: true,
    name: 'status',
    title: i18n.t('common:traceability')
  },
  {
    align: 'right',
    fixed: true,
    name: 'barcode',
    title: i18n.t('tables:barCode')
  },
  {
    align: 'right',
    name: 'productcode',
    title: i18n.t('tables:productCode')
  },
  {
    align: 'right',
    name: 'productdescription',
    title: i18n.t('tables:productDescription')
  },
  {
    align: 'right',
    name: 'slaughterindustrycnpj',
    title: i18n.t('tables:CNPJIndustrySlaughter')
  },
  {
    align: 'right',
    name: 'boningoutindustrycnpj',
    title: i18n.t('tables:CNPJDeboningIndustry')
  },
  {
    align: 'right',
    name: 'slaughterdat',
    title: i18n.t('tables:slaughterDate')
  },
  {
    align: 'right',
    name: 'producedat',
    title: i18n.t('common:productionDate')
  },
  {
    align: 'right',
    name: 'expiresat',
    title: i18n.t('common:expirationDate')
  },
  {
    align: 'right',
    name: 'rawweight',
    title: i18n.t('tables:grossWeight')
  },
  {
    align: 'right',
    name: 'clearweight',
    title: i18n.t('tables:netWeight')
  },
  {
    align: 'right',
    name: 'qtt',
    title: i18n.t('common:qty')
  },
  {
    align: 'right',
    name: 'slaughtersif',
    title: i18n.t('tables:slaughterSIF')
  },
  {
    align: 'right',
    name: 'processsif',
    title: i18n.t('tables:processSIF')
  },
  {
    align: 'right',
    name: 'boningoutsif',
    title: i18n.t('tables:boningSIF')
  },
  {
    align: 'right',
    name: 'countermark',
    title: i18n.t('tables:countermark')
  },
  {
    align: 'right',
    name: 'pallet',
    title: i18n.t('common:palletCode')
  },
  // Unique columns from intColumns
  {
    align: 'right',
    name: 'lote',
    title: i18n.t('tables:batch')
  },
  {
    align: 'right',
    name: 'batchItensInvoice',
    title: i18n.t('tables:batch')
  },
  {
    align: 'right',
    name: 'sledBbd',
    title: i18n.t('tables:sledBbd')
  },
  {
    align: 'right',
    name: 'unitMeasureInvoice',
    title: i18n.t('tables:unitMeasure')
  },
  {
    align: 'right',
    name: 'unitMeasure',
    title: i18n.t('tables:UOM')
  }
]

// Column name lists for each type
export const INNATURA_COLUMNS = [
  'order',
  'cargo',
  'status',
  'barcode',
  'productcode',
  'productdescription',
  'slaughterindustrycnpj',
  'boningoutindustrycnpj',
  'slaughterdat',
  'producedat',
  'expiresat',
  'rawweight',
  'clearweight',
  'qtt',
  'slaughtersif',
  'boningoutsif',
  'countermark',
  'pallet'
]

export const PROCESSADOS_COLUMNS = [
  'order',
  'cargo',
  'status',
  'barcode',
  'productcode',
  'productdescription',
  'producedat',
  'expiresat',
  'rawweight',
  'clearweight',
  'qtt',
  'processsif',
  'countermark',
  'pallet'
]

export const DISTRIBUTION_COLUMNS = {
  viewer: [
    'productcode',
    'productdescription',
    'batchItensInvoice',
    'qtt',
    'unitMeasure',
    'clearweight',
    'unitMeasureInvoice',
    'producedat'
  ],
  admin: [
    'productcode',
    'productdescription',
    'batchItensInvoice',
    'qtt',
    'unitMeasure',
    'clearweight',
    'unitMeasureInvoice',
    'producedat',
    'expiresat'
  ]
}

/**
 * Get columns filtered by business type
 * @param theme - Current theme (optional, used for conditional filtering)
 * @returns Filtered column list
 */
export const getColumnsByTheme = (
  theme: string,
  isAdmin = false
): ColumnsProps[] => {
  const allColumnsList = allColumns()

  const type = getLineTypeByTheme(theme)

  let columnNames: string[] = []

  switch (type) {
    case LINE_TYPES.INNATURA:
      columnNames = INNATURA_COLUMNS
      break
    case LINE_TYPES.PROCESSED:
      columnNames = PROCESSADOS_COLUMNS
      break
    case LINE_TYPES.DISTRIBUTION:
      columnNames = DISTRIBUTION_COLUMNS[isAdmin ? 'admin' : 'viewer']
      break
    default:
      return allColumnsList
  }

  return columnNames
    .map(name => allColumnsList.find(col => col.name === name))
    .filter(Boolean) as ColumnsProps[]
}

// Keep these for backward compatibility
export const columns = (): ColumnsProps[] =>
  getColumnsByTheme(LINE_TYPES.INNATURA)
